import React from 'react';
import { Modal } from 'antd';
import { useToggle } from '@/utils/hooks/useToggle';
import { QuestionMeta } from '@/services/questions/types';
import { getQuestionXamlString } from '@/services/questions';

interface IProps {
  questionMeta: QuestionMeta;
}

const QsPlayer: React.FC<IProps> = ({ questionMeta }) => {
  const [isModalOpen, toggleModal] = useToggle();

  const fetchAndSetPlayerData = async () => {
    try {
      const { data } = await getQuestionXamlString(
        questionMeta.host,
        questionMeta.xaml_url,
        questionMeta.xaml_file
      );

      window.playerWidth = questionMeta.width;
      window.playerHeight = questionMeta.height;
      window.xamlString = data;
      window.pngUrl = `${questionMeta.host}${questionMeta.jpg_url}${questionMeta.jpg_file}`;
    } catch {
      console.log('error occured on player data');
    }
  };

  const loadScript = (src: string) => {
    return new Promise<void>((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.body.appendChild(script);
    });
  };

  const loadPlayerScripts = async () => {
    const scripts = [
      'https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js',
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js',
      '/player/greensocks/TweenMax.js',
      '/player/greensocks/TweenLite.js',
      '/player/greensocks/TimelineMax.js',
      '/player/greensocks/TimelineLite.js',
      '/player/screenfull.js',
      '/player/jquery.fullscreen-min.js',
      '/player/viewCanvas_v1.js',
      '/player/player.js',
    ];

    for (const src of scripts) {
      await loadScript(src);
    }
  };

  const handleOpenVideo = async () => {
    toggleModal(true);

    await fetchAndSetPlayerData();

    try {
      await loadPlayerScripts();
    } catch {
      console.log('error occured while loading video');
    }
  };

  const handleCloseVideo = () => {
    window.location.reload();
  };

  return (
    <>
      <div onClick={handleOpenVideo}>
        <img
          className="mt-4"
          width={400}
          height={100}
          alt="feedback_image"
          src={'/video-player.png'}
        />
      </div>
      <Modal
        open={isModalOpen}
        onCancel={handleCloseVideo}
        footer={null}
        width="100%"
        centered
      >
        <div
          id="player"
          data-sound={`${questionMeta.host}${questionMeta.mp3_url}${questionMeta.mp3_file}`}
          className="style-player !mt-0"
        >
          <canvas id="canvas" className="style-canvas h-full min-h-[660px]" />
          <div id="audio-container" className="style-audio-container w-full">
            <audio
              id="sound"
              controls
              autoPlay
              controlsList="nodownload"
              className="style-sound w-3/4 absolute bottom-[24px]"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default QsPlayer;
